import { render, staticRenderFns } from "./referralPage.vue?vue&type=template&id=3d7338bd&scoped=true&"
import script from "./referralPage.vue?vue&type=script&lang=js&"
export * from "./referralPage.vue?vue&type=script&lang=js&"
import style0 from "./referralPage.vue?vue&type=style&index=0&id=3d7338bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7338bd",
  null
  
)

export default component.exports